import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { checkIfStoryPublic } from "../../../access-type-utils";
import { SectionName } from "../../atoms/section-tag";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import { Authors } from "../../atoms/author";
import { HeroImage } from "../../atoms/hero-image";
import assetify from "@quintype/framework/assetify";
import { ImageCaption } from "../../atoms/image-caption";
import { StoryCard } from "../../molecules/story-card";
import { StoryTags } from "../../atoms/social-tags";
import { CommentingWidget } from "../../atoms/commenting-widget/commenting-widget";
import { isDesktopSizeViewport } from "../../../utils";
import { RequestSubscription } from "../../pages/subscription-page/request-subscription";
import { socialShareSupport } from "../../molecules/social-share";
import { SubscriptionCTA } from "../../molecules/subscription-cta";
import { AmazonPolly } from "../../molecules/amazon-polly/amazon-polly";
import StopPress from "../../molecules/stop-press";
import LoadingIcon from "../../../../assets/images/loader.svg";
import "./listicle.m.css";
import { GiftStoryButton } from "../../molecules/gift-story-button";
import Loader from '../../atoms/loader'
export const ListicleStoryTemplate = props => {
  const [deviceWidth, deviceWidthHandler] = useState("");
  useEffect(() => {
    deviceWidthHandler(!isDesktopSizeViewport() ? "full-width" : "");
  }, []);

  let cardIndex = props.story["bullet-type"] === "123" ? 1 : 0;
  const cardsToBeNumbered = get(props, ["story", "cards"], []).filter(card => card["card-type"] !== "introduction")
    .length;

  const BulletType = card => {
    if (card["card-type"] !== "introduction") {
      if (props.story["bullet-type"] === "123") {
        return <div styleName="bullet-ordering">{cardIndex++}.</div>;
      } else if (props.story["bullet-type"] === "bullets") {
        return <div styleName="bullet-type"></div>;
      } else if (props.story["bullet-type"] === "321") {
        return <div styleName="bullet-ordering">{cardsToBeNumbered - cardIndex++}.</div>;
      }
    }
    return null;
  };

  const isStoryPublic = checkIfStoryPublic(props.story);
  const story = isStoryPublic? props.story: props.hasSubscription ? props.story: props.newStory;
  const storyCards = get(story, ["cards"], []);

  function getStoryCards(cards = [], story = {}, config, hasSubscription) {
    return (
      cards &&
      cards.map((card, index) => {
        const getSubscriptionCTA = get(card, ["metadata", "attributes", "subscriptioncta", 0], "No");
        const getNewsletter = get(card, ["metadata", "attributes", "newsletter", 0], null);
        if (getSubscriptionCTA === "Yes") {
          return (
            <React.Fragment>
              <div styleName="bullets-wrapper" key={index}>
                <div>{BulletType(card, index)}</div>
                <StoryCard card={card} story={story} config={config} />
              </div>
              {getNewsletter && (
              <div className="newsletter-grid story-tags">
                {" "}
                <StopPress planName={getNewsletter} />{" "}
              </div>
            )}
              {!hasSubscription ? (
                <div className="story-tags">
                  {" "}
                  <SubscriptionCTA url={story.slug} />{" "}
                </div>
              ) : null}
            </React.Fragment>
          );
        }
        return (
          <React.Fragment>
          <div styleName="bullets-wrapper" key={index}>
            <div>{BulletType(card, index)}</div>
            <StoryCard card={card} story={story} config={config} />
          </div>
            {getNewsletter && (
              <div className="newsletter-grid story-tags">
                {" "}
                <StopPress planName={getNewsletter} />{" "}
              </div>
            )}
            </React.Fragment>
        );
      })
    );
  }

  function showStoryCards(storyCards, story, config, hasSubscription) {
    return (
      <>
        {getStoryCards(storyCards, story, config, hasSubscription)}
        <div className="story-tags">
          <StoryTags story={story} />
        </div>
        {!hasSubscription && checkIfStoryPublic(story) && (
          <div className="story-tags">{<SubscriptionCTA url={story.slug} />}</div>
        )}
        <div className="metype-widget">
          <CommentingWidget story={story} />
        </div>
      </>
    );
  }

  function getIfNoAccess(storyCards, config, story, hasSubscription,member) {
    const noOfVisibleCards = get(config, ["layout", "no-of-visible-cards-in-a-blocked-story"]);
    console.log(member !== null && hasSubscription === null)
    const eligibleCards = storyCards.slice(0, noOfVisibleCards);
    return (
      <>
        <div>{getStoryCards(eligibleCards, story, config, hasSubscription)}</div>
        {(member !== null && hasSubscription === null)? <div style={{display:'flex',height:'100px',flexDirection:'row',alignContent:'strech',justifyContent:'space-around' }}><Loader color="#ec2227"/></div> :
      <RequestSubscription url={story.slug} />}
      </>
    );
  }

  function getIfHasAccess(storyCards, config, story, hasSubscription) {
    return showStoryCards(storyCards, story, config, hasSubscription);
  }

  function handleAccess(storyCards, config, story, hasSubscription,member) {
    if (hasSubscription) {
      return getIfHasAccess(storyCards, config, story, hasSubscription);
    }
    return getIfNoAccess(storyCards, config, story, hasSubscription,member);
  }

  return (
    <div styleName="listicle-wrapper">
      <div styleName="story-header">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <Headline story={story} isStoryPage />
        <Subheadline story={story} />
        <div>{isStoryPublic || props.hasSubscription ? <AmazonPolly story={story} /> : null}</div>
        <div styleName="author">
          <Authors story={story} />
          {!isStoryPublic && props.hasSubscription ? <GiftStoryButton story={story} /> : null}
        </div>
      </div>
      <div className={`${deviceWidth}`}>
        <HeroImage story={story} />
      </div>
      <ImageCaption story={story} />
      <div styleName="story-content">
        <div styleName="social-share-icons">
          <div styleName="sticky">{socialShareSupport(story)}</div>
        </div>
        <div styleName="story-cards">
          {isStoryPublic
            ? showStoryCards(storyCards, story, props.config, props.hasSubscription)
            : handleAccess(storyCards, props.config, story, props.hasSubscription,props.member)}
        </div>
      </div>
    </div>
  );
};

ListicleStoryTemplate.propTypes = {
  story: PropTypes.object,
  config: PropTypes.config,
  member: PropTypes.member,
  hasSubscription: PropTypes.bool
};

class ListicleStoryAccessWrapper extends React.Component {
  render() {
   
    return (
      <div>
         {/* {(this.props.member && this.props.hasSubscription=== null && !checkIfStoryPublic(this.props.story)) && <div styleName="modal">
              <div styleName="modal-content">
                <img src={assetify(LoadingIcon)} alt="loading" />
              </div>
            </div>} */}
        <ListicleStoryTemplate {...this.props} />
      </div>
    );
  }
}

class ListicleStoryBase extends React.Component {
  render() {
    return <ListicleStoryAccessWrapper {...this.props} />;
  }
}

ListicleStoryBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  member: get(state, ["member"], null),
  hasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], null)
});

export const Listicle = connect(mapStateToProps)(ListicleStoryBase);
